const server =
  process.env.NODE_ENV === "development" ?
	// "http://localhost:8111" :
  "https://mpi.hereshanghai.com" :
  "https://mpi.hereshanghai.com";

export default server;